/* global System */

import withLazyUnveil from 'scripts/higher-order-components/withLazyUnveil'

export default {
  SalesDocumentsBlock: withLazyUnveil({
    loadComponent: () =>
      System.import(/* webpackChunkName: "SalesDocumentsBlock" */ './index'),
    height: 445,
    mobileHeight: 622,
  }),
}
